module.exports = {"cancel-subscription-reminders":{"confirmation-page-text":"Sehr geehrte Kundin, sehr geehrter Kunde, Sie haben angegeben, dass Sie keine Erinnerung mehr erhalten möchten. Nach Ablauf Ihres Abos senden wir Ihnen keine E-Mails mehr. Mit freundlichen Grüßen Arriva Niederlande"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/de/subscriptions.json
// module id = sWyy
// module chunks = 1